import { PropsWithChildren } from 'react'

import { Header } from '../Header'

export function Layout({ children }: PropsWithChildren) {
  return (
    <div className="h-screen bg-off-white p-[60px]">
      <Header />
      <div className="mx-auto mt-[50px] grid place-items-center">
        {children}
      </div>
    </div>
  )
}
